import Compliance1 from "assets/frameworks/compliance-1.png";
import Compliance2 from "assets/frameworks/compliance-2.png";
import AICPA from "assets/frameworks/AICPA.png";
import Compliance3 from "assets/frameworks/compliance-3.png";
import Compliance4 from "assets/frameworks/compliance-4.png";
import { useTranslation } from "react-i18next";

const SecurityTeams = () => {
  const { t } = useTranslation("about");

  return (
    <div className="flex !justify-between items-center flex-col xl:flex-row px-6 md:px-14 py-20 gap-10">
      <div className="xl:w-[40%]">
        <p className="text-[30px] md:text-[36px] text-black capitalize text-center md:text-left">
          {t("securityTeams")}
        </p>
      </div>
      <div className="xl:w-[60%] flex justify-center md:justify-end items-center gap-10 flex-wrap">
        <img
          src={Compliance1}
          alt="Compliance1"
          className="w-[84px] h-[100px]"
        />
        <img
          src={Compliance2}
          alt="Compliance2"
          className="w-[73px] h-[100px]"
        />

        <img
          src={Compliance3}
          alt="Compliance3"
          className="w-[125.7px] h-[100px]"
        />

        <img
          src={Compliance4}
          alt="Compliance4"
          className="w-[121px] h-[100px]"
        />
        <img src={AICPA} alt="AICPA" className="w-[100px] h-[100px]" />
      </div>
    </div>
  );
};

export default SecurityTeams;
